import { OktaAuth } from '@okta/okta-auth-js'

// Centralized Okta configuration to ensure PKCE is used consistently
// PKCE (Proof Key for Code Exchange) is required for SPAs and replaces clientSecret

const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER
const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID

export const oktaConfig = {
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/auth-callback`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  disableHttpsCheck: false,
  postLogoutRedirectUri: window.location.origin
}

export const oktaAuth = new OktaAuth(oktaConfig)
